import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  cardContent: {},
  aboutProject: {
    marginTop: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
  },
  item: {
    padding: theme.spacing(1),
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
  tituloCampo: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
    fontSize: '18px',
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
  dividerTitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))

export default useStyles